export const UNIT_TYPE = [
  {
    point: 'generatorList',
    id: 'generatorIds',
    type: 1,
    name: '发电机'
  },
  {
    point: 'converterList',
    id: 'converterIds',
    type: 2,
    name: '变流器'
  },
  {
    point: 'cableList',
    id: 'cableIds',
    type: 3,
    name: '线缆'
  },
  {
    point: 'towerlist',
    id: 'towerIds',
    type: 4,
    name: '塔筒'
  },
  {
    point: 'bladeList',
    id: 'bladeIds',
    type: 5,
    name: '叶片'
  }
];
